import { Injectable } from '@angular/core';
import {HttpHelperService} from "./http-helper.service";
import {ActivityResult} from "./models/activity/ActivityResult";
import {InfoActivityViewModel} from "./models/activity/InfoActivityViewModel";
import {ActivitySaveResult} from "./models/activity/ActivitySaveResult";
import {RegisterActivityResult} from "./models/activity/RegisterActivityResult";

@Injectable({
  providedIn: 'root'
})
export class ActivitiesService {

  constructor(private httpService: HttpHelperService) { }
  public getCurrentActivity() : Promise<ActivityResult>
  {
    return new Promise<ActivityResult>((resolve, reject) => {
      this.httpService.get<ActivityResult>("activities")
        .then(r => resolve(new ActivityResult(r)))
        .catch(e => reject(e));
    });
  }
  public getInfoActivity(activityId: string) : Promise<InfoActivityViewModel> {
    return new Promise<InfoActivityViewModel>((resolve, reject) => {
      this.httpService.get<InfoActivityViewModel>(`activities/${activityId}`)
        .then(r => {
          resolve(new InfoActivityViewModel(r))
        })
        .catch(e => reject(e));
    });
  }
  public registerActivity(activityId: string) : Promise<RegisterActivityResult> {
    return new Promise<RegisterActivityResult>((resolve, reject) => {
      this.httpService.post<RegisterActivityResult>(`activities/${activityId}`, null)
        .then(r => {
          resolve(new RegisterActivityResult(r))
        }).catch(e => reject(e));
    });
  }
}
